export const COLOR_STOP_HOLDER_CLASSNAME = 'csh';
